import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const PageNotFound = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const goHome = () => {
    navigate("/");
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center",
        backgroundColor: "#f5f5f5",
      }}
    >
      <Typography variant="h1" color="primary" gutterBottom>
        {t("notFound.title")}
      </Typography>
      <Typography variant="h6" color="textSecondary" gutterBottom>
        {t("notFound.message")}
      </Typography>
      <Button variant="contained" color="primary" onClick={goHome}>
        {t("notFound.button")}
      </Button>
    </Box>
  );
};

export default PageNotFound;
